/*
*###############################################################################
*Module Name                   : ProductBundleGroupContent.js                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, July 25th 2022, 10:14:01 am           #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPMultiSelectDropdown from "framework/components/DPMultiSelectDropdown"
import ReactPaginate from 'react-paginate';
import _ from 'lodash'

const ProductBundleGroupContent = ({
    CodeValue,
    CodeonChange,
    DescValue,
    DescOnChange,
    disabled,
    SwonChange,
    ActiveSw,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    disabledCode,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    menuCode,
    autoCode,
    GetSelectedGroupCode,
    Tog_backdrop_group,
    ShowTog_backdrop_group,
    GroupDesc,
    SetGroups,
    groups,
    DataTables,
    SetDatatable,
    paginationToggle
}) => {
    //*** useState to save table data */
    const [HeadColumns, setHeadColumns] = useState([])
    //*** End of useStates */

    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    const ApiURL = window.Links.ApiURL

    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTables.slice(indexOfFirstPost, indexOfLastPost)

    const handleSelectAllSwitch = (e) => {
        const updatedDataTables = DataTables.map((item) => ({
            ...item,
            check: e,
        }));
        SetDatatable(updatedDataTables);
    };

  useEffect(() => {
    setCurrentPage(1)
  }, [paginationToggle])

    async function tog_backdrop() {
        modelTrigger();
    }

    //modal props
    const columns = [{
        field: "BUN_CODE",
        title: "Code",
        align: "center",
    },
    {
        field: "BUN_DESC",
        title: "Description",
        align: "center",
    },];

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];

    //Table data
    var searchData = [];
    const TableDataBuilder = (id, Data) => {
        return { "id": id, "code": Data.code, "name": Data.name, "active": Data.status == '1' ? 'Active' : 'Inactive' }
    }

    function handleSwitchChanges(e, values, index) {

        const change = values;
        if (e) {
            change.check = true
        } else {
            change.check = false
        }

        var newStoles = [];

        for (var i = 0; i < groups.length; i++) {
            if (groups[i].code == change.code) {
                newStoles.push(change);
            } else {
                newStoles.push(groups[i]);
            }
        }

        SetGroups(newStoles);
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={7} className="mb-4-sm">
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBoxButton
                                            rowClass="mb-4-sm"
                                            labelText="Code *"
                                            textType="text"
                                            maxLength="5"
                                            value={CodeValue}
                                            onChange={CodeonChange}
                                            onBlur={CodeOnBlur}
                                            disabled={disabled == true ? disabled : disabledCode}
                                            onButtonClick={onButtonClick}
                                            btnDisable={disabled == true ? disabled : btnDisable}
                                            placeholder={autoCode}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Button
                                            onClick={() => {
                                                tog_backdrop()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                            disabled={SearchDisable}
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Description *"
                                            textType="text"
                                            maxLength="50"
                                            value={DescValue}
                                            onChange={DescOnChange}
                                            disabled={disabled}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={3}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className="col-md col-form-label-sm"
                                        >Active</Label></Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={SwonChange}
                                            checked={ActiveSw}
                                            disabled={disabled}

                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={12} md={10} className="mb-4-sm">
                                        <DPTextBox
                                            rowClass="mb-4-sm"
                                            labelText="Select group *"
                                            textType="text"
                                            maxLength="50"
                                            value={GroupDesc}
                                            onChange={DescOnChange}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col sm={12} md={2} className="mb-4-sm">
                                        <Button
                                            disabled={disabled}
                                            onClick={Tog_backdrop_group}
                                            color="success"
                                            className="btn-sm"
                                        >
                                            <i
                                                className="mdi mdi-search-web"
                                                style={{ fontSize: "12px" }}
                                            ></i>
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>

                                    <table className="custom-table table-bordered table-sm rounded">
                                        <thead className='table-secondary'>
                                            <tr>
                                                <th>Code</th>
                                                <th>Description</th>
                                                <th>
                                                    <DPSwitch
                                                        checked={DataTables.every((item) => item.check == true) ? true : false}
                                                        onChange={handleSelectAllSwitch}
                                                        disabled={disabled}

                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentPosts.map((values, index) => {
                                                return (
                                                    <GroupTableRow
                                                        DataTables={DataTables}
                                                        values={values}
                                                        index={index}
                                                        handleSwitchChanges={handleSwitchChanges}
                                                        disabled={disabled}
                                                        indexOfFirstPost={indexOfFirstPost}
                                                    />
                                                )

                                            })
                                            }
                                        </tbody>

                                    </table>
                                </Row>
                                <Row className='mt-1'>
                                    <Col md="12">
                                        <ReactPaginate
                                            previousLabel={'Previous'}
                                            nextLabel={'Next'}
                                            breakLabel={'...'}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            pageCount={Math.ceil(DataTables.length / postsPerPage)}
                                            pageRangeDisplayed={5}
                                            onPageChange={handlePageClick}
                                            forcePage={currentPage - 1}
                                            renderOnZeroPageCount={null}
                                            activeClassName={'active'}
                                            activeLinkClassName={'page-link'}
                                            containerClassName={'pagination justify-content-end pagination-sm'}
                                        />
                                    </Col>
                                </Row>

                            </Col>
                            <DPSearchBoxDynamic
                                searchData={Datatablesub}
                                columns={columns}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"PROBUN"}
                                MenuCode={menuCode}
                                KeyVal={'PRO'}
                                searchBy={'BUN_CODE'}
                                FilterStr={groupFilter}
                            />

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={HeadColumns}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={ShowTog_backdrop_group}
                                toggle={Tog_backdrop_group}
                                getSelect={GetSelectedGroupCode}
                                APIURL={ApiURL}
                                URLPath={"GROUPS"}
                                MenuCode={menuCode}
                                KeyVal={"GRP"}
                                searchBy={"GS_FILENO"}
                                FilterStr={groupFilter}
                            />
                        </Row>
       

                        <Row>

                        </Row>

           

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />

                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default ProductBundleGroupContent


const TableRow = ({ FormRow, Key, disabled, clearBundle, procodeGrid }) => {
    const [code, setcode] = useState(
        FormRow.code != undefined ? FormRow.code : ""
    )
    const [desc, setdesc] = useState(
        FormRow.name != undefined ? FormRow.name : ""
    )
    const [Groupdesc, setGroupdesc] = useState(
        FormRow.groupName != undefined ? [] : []
    )
    const [groupOptions, setgroupOptions] = useState([])

    const [GroupId, setGroupId] = useState("")

    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")

    useEffect(async () => {

        await fetch(`${ApiURL}GroupSetup/ProBunGRP/${FormRow.code}`, {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        })
            .then(Response => Response.json())
            .then(responseData => {
                var dt = responseData.data
                setgroupOptions(dt)
            }).catch(error => {
                console.log(error)
            })

    }, [])


    /* Here is the explanation for the code above:
    1. We are using the map function to iterate through the Groupdesc array.
    2. We are using the value property of the array item to get the value of the group.
    3. We are using the concat function to combine the group items into one string.
    4. We are using the setGroupId function to set the group id. */

    useEffect(() => {
        var groupitems = []
        Groupdesc.map(item => {
            groupitems = groupitems.concat(item.value)
        })
        setGroupId(groupitems.join(","))
    }, [Groupdesc])


    useEffect(() => {
        setGroupdesc([])
    }, [clearBundle])


    useEffect(async () => {
        async function getData() {
            if (procodeGrid != "") {
                await fetch(`${ApiURL}ProductBundle/search/${procodeGrid}/${FormRow.code}`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
                })
                    .then(Response => Response.json())
                    .then(responseData => {
                        var dt = responseData.data
                        setGroupdesc(dt)
                    }).catch(error => {
                        console.log(error)
                    })
            }
        }

        getData()

    }, [procodeGrid])




    //* End Code Validation   */
    return (
        <tr key={FormRow.id}>
            <td style={{ display: "none" }}>
                <Row className="mb-3">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            disabled={true}
                            id={"txtCode" + Key}
                            value={code}
                            onChange={e => {
                                setcode(e.target.value)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "150px" }}>
                <Row className="mb-3">
                    <Col sm={12} md={12}>
                        <Label
                            htmlFor="example-text-input"
                            className="col-md col-form-label-sm"
                        >{desc}</Label>
                    </Col>
                </Row>
            </td>
            <td style={{ width: "400px" }}>
                <Row>
                    <Col sm={12} md={11} style={{ width: "400px" }}>
                        <DPMultiSelectDropdown
                            selected={Groupdesc}
                            setSelected={setGroupdesc}
                            options={groupOptions}
                            labelHide={true}
                            disabled={disabled}
                        />
                    </Col>
                    <Col sm={12} md={1} style={{ display: "none" }}>
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText="Code"
                            textType="text"
                            maxLength="8"
                            disabled={disabled}
                            id={"txtGroupcode" + Key}
                            value={GroupId}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td>
        </tr>
    )
}



//function of group select
const GroupTableRow = ({ values, index, disabled, handleSwitchChanges, indexOfFirstPost }) => {
    return (
        <tr key={values.id}>
            <td>{values.code}</td>
            <td>{values.name}</td>
            {/* <Col sm={12} md={1} className="mb-12-sm w" style={{ width: '80px' }} > */}
            <DPSwitch
                disabled={disabled}
                checked={values.check}
                onChange={(e) => {
                    handleSwitchChanges(e, values, index + indexOfFirstPost)
                }}
            />
            {/* </Col> */}
        </tr>
    )
}


